import { render, staticRenderFns } from "./CalendarOv.vue?vue&type=template&id=0dde410c"
import script from "./CalendarOv.vue?vue&type=script&lang=js"
export * from "./CalendarOv.vue?vue&type=script&lang=js"
import style0 from "./CalendarOv.vue?vue&type=style&index=0&id=0dde410c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports